export default __webpack_public_path__ + "static/media/image-51.a5abceac.png";